import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useEffect } from "react";
import "../../../styles/Dataset.css";
import "../../../styles/KubeflowPage.css";
import "../../../styles/org-buttons.css";
import { pageText } from "../../../utils/pageText";
import { buttonText } from "../../../utils/buttonText";

function ProgressBar({ progress, interval = 1000 }) {

  useEffect(() => {
    const timer = setInterval(() => {
      if (progress >= 100) {
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [progress, interval]);

  return (
    <div className="progress-bar-container">
      <div
        className="progress-bar-fill"
        style={{
          width: `${progress}%`,
          backgroundColor: 'blue',
          height: '15px',
          borderRadius: '5px'
        }}
      ></div>
      <div className="percentage-text">{`${progress}%`}</div>
    </div>
  );
}

function StatusCheckPage(props) {
  const { reloadStatus, tasksStatus, progress } = props;

  return (
    <Modal
      fullscreen={true}
      show={props.show}
      onHide={props.onHide}
      className="Status_Modal_Dialog"
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title>Status Check Page</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="kubeflow-tasks">
          {tasksStatus &&
            Object.values(tasksStatus).map((item, index) => {
              let currentProgress =
                item.status === "finished" || item.status === "Succeeded" || item.status === "no_detections" || item.status === "save-error"
                  ? 100
                  : item.status === "started"
                  ? 50
                  : 0;
              return (
                <TaskItem
                  key={`${item.rq_id}`}
                  item={item}
                  reloadStatus={reloadStatus}
                  progress={currentProgress}
                />
              );
            })}
        </div>
      </Modal.Body>
      <Modal.Footer className="org-modal-footer">
        <button type="button" className="org-btn org-btn-secondary" onClick={props.onHide}>
          {buttonText("Close")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function TaskItem(props) {
  const { item, reloadStatus, progress} = props;

  const deleteTask = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this task?"
    );
    if (confirmDelete) {
      axios
        .delete(`/models/docker/task/delete?prelabel_id=${item.prelabel_id}`)
        .then((response) => {
          reloadStatus();
        })
        .catch((error) => {
          let errorMsg = error.response.data;
          window.alert(errorMsg);
        });
    }
  };

  const candelete = ["Succeeded", "finished", "Failed", "failed", "no_detections", "save-error"].includes(
    item.status
  );

  const isError = ["Failed", "failed", "no_detections", "save-error"].includes(item.status);

  return (
    <div
      className={`card ${
        item.status === "Succeeded" || item.status === "finished"
          ? "Succeeded"
          : item.status === "Failed" || item.status === "failed" || item.status === "no_detections" || item.status === "save-error"
          ? "Failed"
          : "Running"
      }`}
      style={{ width: "18rem" }}
    >
      {candelete && (
        <div className="container-fluid">
          <div className="row">
            <div className="col col-xl-12 d-flex justify-content-end px-2 py-2">
              <button
                type="button"
                className="btn-close"
                aria-label={buttonText("Close")}
                onClick={() => deleteTask(item.prelabel_id)}
              ></button>
            </div>
          </div>
        </div>
      )}
      <div className="card-body">
        <h5 className="card-title">{item.start_time}</h5>
        <div className="task-items-container">
          <p>dataset: {item.dataset_name}</p>
          <p>{pageText("Task Mode")}: {pageText(item.task_mode === "feature-extraction" ? "Embedding" : "Pre-labeling")}</p>
          <p>model: {item.model_name}</p>
          <p>status: {item.status}</p>
          {isError && item.result && (
            <p className="text-danger small mb-1 mt-1">Error: {item.result}</p>
          )}
          <ProgressBar progress={progress} />
        </div>
      </div>
    </div>
  );
}

export default StatusCheckPage;
